export const msalConfig = {
  auth: {
    clientId: "c46ae988-a71c-404a-a2b0-070d3df5822e",
    authority: "https://login.microsoftonline.com/27272476-d569-411c-ab78-6d3f3b7596e5",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    "https://api.businesscentral.dynamics.com/Financials.ReadWrite.All",
    "https://api.businesscentral.dynamics.com/user_impersonation",
  ],
};

export const BC_CONFIG = {
  tenantId: "27272476-d569-411c-ab78-6d3f3b7596e5",
  // Producción. Sandbox para pruebas: environment="SBX_ProdCopy_25_5", company="ADELANTE_DESARROLLOS"
  environment: "Production",
  company: "ADELANTE_DESARROLLOS_NUEVA",
  baseUrl: "https://api.businesscentral.dynamics.com/v2.0",
};
